module.exports = __webpack_public_path__ + "media/images/close-71015756baf0e5b93a73e39cb8370001.svg";